export interface Address {
  streetLine1: string;
  streetLine2: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
}

export const emptyAddress: Address = {
  streetLine1: '',
  streetLine2: '',
  city: '',
  state: '',
  country: 'US',
  zipCode: '',
};
